import { Platform } from 'react-native';
import { getNativeAppHeaders } from '../utilities/NativeHelpers';
import { version } from '@omni/version';

const debug = require('debug')('tca:kit:Downloader:GetAppHeaders');

export default async (appKey?: string): Promise<Record<string, string>> => {
  let appHeaders: Record<string, string> = {};
  try {
    const headerString = await getNativeAppHeaders();
    appHeaders = JSON.parse(headerString);
    appHeaders['sap-omni-version'] = version; // Override native omni version with our known package version
  } catch {
    debug('could not fetch app headers');

    // This is necessary for the Dev app when debugging in the Simulator
    appHeaders['sap-omni-version'] = version;
    if (appKey) {
      appHeaders['sap-active-appkey'] = appKey;
    }

    appHeaders['sap-app-version'] = version;
    appHeaders['sap-device-os'] = Platform.OS;
  }

  if (Platform.OS === 'web') {
    // add web headers
    appHeaders['sap-omni-version'] = version;
    if (appKey) {
      appHeaders['sap-active-appkey'] = appKey;
    }

    appHeaders['sap-app-version'] = version;
    appHeaders['sap-platform'] = 'web';
  }

  return appHeaders;
};
